import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { Configure, InstantSearch } from 'react-instantsearch-dom';
import { Columns } from 'ui-base';
import { algoliaClient, INDEX_PRODUCTS, userToken, ALGOLIA_BASE_FILTERS } from 'src/lib/algolia';
import { MyFilter, SortFilter } from '../widgets';
import { ProductListContainer } from '../productList';
import { history, SearchState, Url } from '../utils';
import { ProductListingPageProvider } from '../context';
import { AsideColumn } from '../widgets/AsideColumn';
import styles from './Page.module.scss';
import '../index.global.scss';

class CollectionPage extends Component {
  filters;

  handle;

  constructor(props) {
    super(props);
    this.state = {
      searchState: SearchState.defaultSearchState,
    };
    this.defaultIndex = INDEX_PRODUCTS;
    this.setCollectionFilters();
  }

  componentDidMount() {
    const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    if (params && params.boost) {
      const optionalFilters = params.boost.split(';');
      this.setState({
        optionalFilters
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('updateHeaderFacet', this.OnHeaderFacetUpdate);
  }

  setCollectionFilters = () => {
    const paths = window.location.pathname.split('/').filter((x) => x && x !== 'collections');

    if (paths && paths.length) {
      const defaultFilter = ALGOLIA_BASE_FILTERS;
      this.handle = paths[0];
      this.filters = `${defaultFilter} AND collectionHandles:${this.handle}`;
      // Split tags path: e.g. /collections/new-arrivals/gender-mens+category-tops
      if (paths.length === 2) {
        const tags = paths[1].split('+').join(' AND tags:');
        this.filters += ` AND tags:${tags}`;
      }
    }
    window.addEventListener('updateHeaderFacet', this.OnHeaderFacetUpdate);
  };

  OnHeaderFacetUpdate = () => this.onSearchStateChange(Url.parseQueryParams());

  // HOF to sync url bar with searchState. Useful to revert url in child components
  syncUrl = (searchSate) => (lockPagination) => {
    const url = Url.searchStateToUrl(searchSate, lockPagination);
    history.replace(url, searchSate);
    window.dispatchEvent(new CustomEvent('changeSearchState', { detail: { url: `${window.location.origin}${url}` } }));
  };

  onSearchStateChange = (searchState) => {
    // Update State
    this.setState({ searchState });
    // Update URL params
    this.syncUrl(searchState)(false);
  };

  render = () => {
    const { listName, extraFacets, enableSeoThumbnails, featureTile } = this.props;
    const { searchState, optionalFilters } = this.state;

    return (
      <ProductListingPageProvider extraFacets={extraFacets} searchState={searchState} featureTile={featureTile}>
        <div className={styles.root}>
          <div className={`container ${styles.container}`}>
            <div>
              <InstantSearch
                indexName={this.defaultIndex}
                searchClient={algoliaClient}
                searchState={searchState}
                onSearchStateChange={this.onSearchStateChange}
              >
                <Configure
                  userToken={userToken}
                  optionalFilters={optionalFilters}
                  hitsPerPage={48}
                  filters={this.filters}
                  ruleContexts={optionalFilters ? undefined : [`collection-${this.handle}`]}
                  enableRules={!searchState.sortBy || searchState.sortBy === this.defaultIndex}
                  clickAnalytics
                  analyticsTags={['web', 'collection', this.handle]}
                />
                <Columns className={styles.columns}>
                  <AsideColumn />
                  <Columns.Column className={styles.contentColumn}>
                    <SortFilter INDEX={INDEX_PRODUCTS} defaultIndex={this.defaultIndex} />
                    <MyFilter />
                    <br />
                    <ProductListContainer
                      listName={listName}
                      enableSeoThumbnails={enableSeoThumbnails}
                      syncPageUrl={this.syncUrl(searchState)}
                    />
                  </Columns.Column>
                </Columns>
              </InstantSearch>
            </div>
          </div>
        </div>
      </ProductListingPageProvider>
    );
  };
}

CollectionPage.propTypes = {
  listName: PropTypes.string.isRequired,
  extraFacets: PropTypes.array,
  enableSeoThumbnails: PropTypes.bool,
  featureTile: PropTypes.object,
};

CollectionPage.defaultProps = {
  extraFacets: null,
};

export { CollectionPage };
